// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"adf56f72","453":"ad6eb26e"}[chunkId] + ".chunk.js";
};